const defaultString = (str) => (typeof str === 'string' ? str : '');

export default (descr, htmlDescr, pinJoin) => {
  const description = defaultString(descr);
  let title = description;

  if (pinJoin) {
    const seoDescription = pinJoin.seo_description;
    if (seoDescription) {
      const normalizedSEODescription = seoDescription.toLowerCase();
      const htmlDescription = defaultString(htmlDescr);
      if (
        normalizedSEODescription !== description.toLowerCase() &&
        normalizedSEODescription !== htmlDescription.trim().toLowerCase()
      ) {
        title = seoDescription;
      }
    }
  }

  if (pinJoin) {
    let visualAnnotations = pinJoin.visual_annotation;
    if (visualAnnotations) {
      visualAnnotations = visualAnnotations.join(', ');
      if (title) {
        title += ' ';
      }
      title += visualAnnotations;
    }
  }

  return title;
};
